import React, { useContext, useEffect, useState } from 'react';
import '../styles/MapContainer.css'
import dbActions from '../utils/db';
import { GoogleMap, Marker } from '@react-google-maps/api';
import MapContainerProps from '../interfaces/MapContainerProps';
import Location from '../interfaces/Location';
import LandingViewContext from '../context/LandingViewContext';
import AppContext from '../context/AppContext';


const MapContainer: React.FC<MapContainerProps> = ({marker, setSelectedLocation}) => {
  const [locations, setLocations] = useState<Location[]>([]); 
  const { refreshLocations, setRefreshLocations } = useContext(LandingViewContext);
  const [map, setMap] = React.useState<any>(null);
  const [zoom, setZoom] = React.useState(9);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [tooltipContent, setTooltipContent] = useState<string | null>(null);
  const [tooltipPosition, setTooltipPosition] = useState<{ top: number; left: number } | null>(null);
  const { addressRef } = useContext(AppContext);

  // const [added, setAdded] = React.useState(false);

  useEffect(() => {
    (async() => {
      const retrieved_locations = await dbActions.getLocations();
      setLocations(retrieved_locations);
      setRefreshLocations(false);
    })();
  }, [refreshLocations])

  const onLoad = React.useCallback(function callback(map: any) {
    map.setZoom(9);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map: any) {
    setMap(null)
  }, [])

  const containerStyle = {
    width: '75%',
    height: '500px',
  };

  const [center, setCenter] = useState({
    lat: -34.61315,
    lng: -58.37723,
  });

  const handleClickedMarker = (location: Location) => {
    setSelectedLocation(location);

    setTimeout(() => {
      if (addressRef.current) {
        addressRef.current.scrollIntoView({ behavior: 'smooth' });
        addressRef.current.focus();
      }
    }, 500); // 0.5 seconds delay
  }

  useEffect(() => {
    setTimeout(() => {
        setZoom(9);
    }, 300);
  }, [])

  useEffect(() => {
    if (marker.geometry !== undefined){
      setCenter(marker.geometry.location);
      setZoom(15);
    }
  }, [marker])

  const handleMouseOver = (location: Location, event: any) => {
    const mapBounds = map.getDiv().getBoundingClientRect();
    const tooltipX = event.domEvent.screenX - mapBounds.left;
    const tooltipY = event.domEvent.screenY - mapBounds.top - 100;
    setTooltipPosition({ top: tooltipY, left: tooltipX });
    setTooltipContent(location.place.address);
    setShowTooltip(true);
  };

  const handleMouseOut = () => {
    setShowTooltip(false);
  };

  return (
    <div className='map-container'>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {locations.map((location) => { 
          return (
            <span id={location.locationId}>
              <Marker 
                position={location.place.geometry.location} 
                onClick={() => handleClickedMarker(location)} 
                onMouseOver={(e) => handleMouseOver(location, e)}
                onMouseOut={handleMouseOut}
              />
              {showTooltip && tooltipPosition && (
                <div className='tooltip show' style={{ top: `${tooltipPosition.top}px`, left: `${tooltipPosition.left}px` }}>
                  {tooltipContent}
                </div>
              )}
            </span>)
        })}
      </GoogleMap>
    </div>
  )
};

export default MapContainer;
